'use client';
import React from 'react';

const footerLinks = {
  services: [
    { label: 'تصميم المواقع', href: '#services' },
    { label: 'التسويق الرقمي', href: '#services' },
    { label: 'إدارة السوشيال ميديا', href: '#services' },
    { label: 'الهوية البصرية', href: '#services' },
    { label: 'حلول الذكاء الاصطناعي', href: '#services' },
    { label: 'تطبيقات مخصصة', href: '#services' },
  ],
  company: [
    { label: 'من نحن', href: '#about' },
    { label: 'نماذج استعراضية', href: '#portfolio' },
    { label: 'تواصل معنا', href: '#contact' },
  ],
};

export default function Footer() {
  const handleNavClick = (href: string) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer
      className="relative overflow-hidden"
      style={{ background: 'linear-gradient(180deg, #080808 0%, #040404 100%)' }}
    >
      {/* Top divider */}
      <div className="section-divider"></div>

      {/* Main footer */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-5">
              <div>
                <span className="font-black text-2xl">
                  <span className="text-white">Monetiz</span><span style={{ color: '#f59e0b' }}>X</span>
                </span>
                <p className="text-amber-600 text-xs font-medium -mt-1">.agency</p>
              </div>
            </div>

            <p className="text-gray-400 leading-relaxed mb-6 max-w-sm">
              وكالة رقمية متخصصة تقدم حلولاً متكاملة لمساعدة الشركات ورواد الأعمال على النجاح في العالم الرقمي.
            </p>

          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-bold text-lg mb-5">خدماتنا</h3>
            <ul className="space-y-3">
              {footerLinks.services.map((link) => (
                <li key={link.label}>
                  <button
                    onClick={() => handleNavClick(link.href)}
                    className="text-gray-400 hover:text-amber-400 transition-colors text-sm flex items-center gap-2 group"
                  >
                    <span className="w-1 h-1 rounded-full bg-amber-600 group-hover:bg-amber-400 transition-colors"></span>
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-white font-bold text-lg mb-5">الشركة</h3>
            <ul className="space-y-3 mb-8">
              {footerLinks.company.map((link) => (
                <li key={link.label}>
                  <button
                    onClick={() => handleNavClick(link.href)}
                    className="text-gray-400 hover:text-amber-400 transition-colors text-sm flex items-center gap-2 group"
                  >
                    <span className="w-1 h-1 rounded-full bg-amber-600 group-hover:bg-amber-400 transition-colors"></span>
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>

            {/* WhatsApp CTA */}
            <a
              href="https://wa.me/9647713020752"
              target="_blank"
              rel="noopener noreferrer"
              className="whatsapp-btn flex items-center gap-2 px-4 py-3 rounded-xl text-white font-semibold text-sm w-full justify-center"
            >
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
              </svg>
              تواصل عبر واتسآب
            </a>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="section-divider"></div>
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-gray-600 text-sm">
            &copy; 2026 <span className="text-white">Monetiz</span><span style={{ color: '#f59e0b' }}>X</span> Agency. جميع الحقوق محفوظة.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-gray-600 hover:text-gray-300 text-sm transition-colors">سياسة الخصوصية</a>
            <span className="text-gray-700">|</span>
            <a href="#" className="text-gray-600 hover:text-gray-300 text-sm transition-colors">شروط الخدمة</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
